import { required, optional } from 'AppReact/schema';

export const tenantUnit = {
  allow_sms: optional('boolean'),
  email: optional('string'),
  id: required('integer'),
  number: optional('string'),
  phone: optional('string'),
  property: required('string'),
  property_id: required('integer'),
  tenant_id: optional('integer'),
  tenant_name: optional('string'),
}


export const tenantUnitDefault = {
  allow_sms: null,
  email: null,
  id: 0,
  number: "",
  phone: null,
  property: "",
  property_id: 0,
  tenant_id: null,
  tenant_name: null,
}
